define.alias("shared/components/shared/credentials/password-input", "preview-grid/components/shared/credentials/password-input");